import React from "react";

export const MarqueeStrip = () => (
  <div className="bg-afwn-surface border-y border-afwn-navy/5 py-4 overflow-hidden" data-testid="marquee">
    <div className="afwn-marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {["Evidence-Informed", "Trauma-Informed", "24/7 AI Assistant", "52-Week Program", "Wellness Education", "Self-Help Tools"].map((t) => (
            <span key={t} className="font-heading italic text-2xl text-afwn-slate mx-8 whitespace-nowrap flex items-center gap-8">{t} <span className="text-afwn-amber not-italic">•</span></span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
